import { Component, OnDestroy, Input } from '@angular/core';

// ionic
import { PopoverController } from '@ionic/angular';

// rxjs
import { Subject } from "rxjs";

// models
import { Participant } from "../../models/participant";
import { ChatGroup } from "../../models/chat-group";

// providers
import { PlatformService } from "../../services/platform.service";
import { ChatGroupsService } from "../../services/chat-groups.service";
import { OverlayService } from "../../services/overlay.service";

@Component({
    selector: 'chat-group-attendees-action-menu',
    templateUrl: './chat-group-attendees-action-menu.component.html',
    styleUrls: ['./chat-group-attendees-action-menu.component.scss']
})
export class ChatGroupAttendeesActionMenu implements OnDestroy {

    /**
     * selected participant
     *
     * @type string
     */
    @Input() participant: Participant;

    /**
     * selected chat group
     *
     * @type string
     */
    @Input() chatGroup: ChatGroup;

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * constructor
     *
     * @param eventService
     */
    constructor(
        public plt: PlatformService,
        public overlayService: OverlayService,
        public popoverController: PopoverController,
        public chatGroupService: ChatGroupsService
    ) {}

    async remove() {
        await this.popoverController.dismiss({
            item: this.participant,
            action: 'remove'
        });
    }

    async addAdmin(role: string) {
        await this.popoverController.dismiss({
            item: this.participant,
            action: 'add-admin',
            role: role
        });
    }

    async removeAdmin() {
        await this.popoverController.dismiss({
            item: this.participant,
            action: 'remove-admin'
        });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

}
